import { render, staticRenderFns } from "./qrCodeSquare.vue?vue&type=template&id=bb513ee0&scoped=true"
import script from "./qrCodeSquare.vue?vue&type=script&lang=js"
export * from "./qrCodeSquare.vue?vue&type=script&lang=js"
import style0 from "./qrCodeSquare.vue?vue&type=style&index=0&id=bb513ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb513ee0",
  null
  
)

export default component.exports